var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "image-preview-content" },
    [
      _c("ImagePreviewToolbarComponent", {
        ref: "toolbar",
        attrs: { zoom: _vm.zoom },
        on: {
          "zoom-in-event": _vm.zoomIn,
          "zoom-out-event": _vm.zoomOut,
          "close-viewer-event": _vm.closeViewerEvent,
        },
      }),
      _vm.isLoading
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer-component",
          })
        : _vm._e(),
      _c("ejs-imageeditor", {
        ref: "imageEditorObj",
        attrs: {
          id: "image-editor",
          width: "100%",
          height: "100%",
          toolbar: [],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }